// src/queries/pages/dashboard/authApiConfig.js

/**
 * AUTH API CONFIGURATION
 * Endpoints map to pms-api NestJS auth controller at /api/v1/auth/*
 */
export const authConfig = {
  /* -------------------------------------------------------------------------- */
  /*                            AUTH OPERATIONS                                 */
  /* -------------------------------------------------------------------------- */

  login: {
    key: "login",
    url: "/api/v1/auth/login",
    method: "POST",
    options: {
      retry: 0,
      onSuccessMessage: "Logged in successfully",
      onErrorMessage: "Failed to sign in",
    },
  },

  getMyProfile: {
    key: "getMyProfile",
    url: "/api/v1/auth/my-profile",
    method: "GET",
    options: {
      staleTime: Infinity,
    },
  },

  getMyPermissions: {
    key: "getMyPermissions",
    url: "/api/v1/auth/my-permissions",
    method: "GET",
    options: {
      staleTime: Infinity,
    },
  },

  logout: {
    key: "logout",
    url: "/api/v1/auth/logout",
    method: "POST",
    options: {
      retry: 0,
      onSuccessMessage: "Signed out successfully",
      onErrorMessage: "Failed to sign out",
    },
  },

  forgotPassword: {
    key: "forgotPassword",
    url: "/api/v1/auth/forgot-password",
    method: "POST",
    options: {
      retry: 0,
      onSuccessMessage: "Password reset email sent",
      onErrorMessage: "Failed to send password reset email",
    },
  },

  resetPassword: {
    key: "resetPassword",
    url: "/api/v1/auth/reset-password",
    method: "POST",
    options: {
      retry: 0,
      onSuccessMessage: "Password reset successfully",
      onErrorMessage: "Failed to reset password",
    },
  },

  changePassword: {
    key: "changePassword",
    url: "/api/v1/auth/change-password",
    method: "POST",
    options: {
      retry: 0,
      onSuccessMessage: "Password changed successfully",
      onErrorMessage: "Failed to change password",
    },
  },

  validateToken: {
    key: "validateToken",
    url: "/api/v1/auth/validate-token",
    method: "GET",
    options: {
      retry: 0,
    },
  },

  setPassword: {
    key: "setPassword",
    url: "/api/v1/auth/set-password",
    method: "POST",
    options: {
      retry: 0,
      onSuccessMessage: "Password set successfully",
      onErrorMessage: "Failed to set password",
    },
  },
};
